var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 16,
    viewBox: "0 0 26 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.28 15.5C2.07 15.5 0.5 13.49 0.5 10.62 0.5 5.58 3.6 0.5 7.28 0.5c2.04 0 3.63 1.22 5.05 3.32C13.72 1.72 15.39 0.5 17.44 0.5c3.68 0 6.78 5.07 6.78 10.12 0 2.88-1.62 4.88-3.86 4.88-1.96 0-3.31-1.47-5.17-4.26-.62-.93-1.2-1.84-1.9-2.95-.7 1.11-1.3 2.02-1.92 2.95-1.86 2.79-3.2 4.26-5.17 4.26Zm3.03-3.08c.95 0 1.67-.89 3.31-3.48-1.24-2.03-2.2-3.16-3.3-3.16-1.43 0-2.52 1.98-2.52 4.49 0 1.41.6 2.15 1.5 2.15Zm11.08 0c.91 0 1.5-.74 1.5-2.15 0-2.51-1.09-4.49-2.52-4.49-1.11 0-2.07 1.13-3.31 3.16 1.65 2.59 2.37 3.48 3.33 3.48Z",
    fill: "#0866FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaLogo);
export default __webpack_public_path__ + "static/media/meta-logo.d0c15cbb46be7bee9b78df25d8357cb5.svg";
export { ForwardRef as ReactComponent };